<template>
    <v-row class="tablo-wrapper" no-gutters>
        <v-col>
            <div class="right-block" ref="rightBlock">
                <div class="main-block">
                    <div class="main-block-header">
                        <div>Тізім санаты</div>
                        <div class="caterody-name">{{ categories[selectedCategoryIndex].name }}</div>
                        <div>Осы санатқа тіркелгендер саны: {{ userList.filter(item => selectedCategoryIndex != 0 ? (item.privilege && item.privilege.id == categories[selectedCategoryIndex].id) : true).length }}</div>
                    </div>
                    <div class="main-block-content">
                        <v-simple-table>
                            <template v-slot:default>
                                <tr v-for="item, index in userList.filter(item => selectedCategoryIndex != 0 ? (item.privilege && item.privilege.id == categories[selectedCategoryIndex].id) : true)" :key="index" :class="{'active': searchVal == item.iin}" :ref="searchVal == item.iin ? 'active' : null">
                                <template v-if="selectedCategoryIndex == 0">
                                    <td>{{ item.raiting_number }}</td></template>

                                    <template v-else>
                                    <td>{{ item.raiting_privilege_number }}</td></template>
                                 
                                    <td width="60%"><b>{{ item.full_name }}</b></td>
                                    <td class="privilege-name"><template v-if="item.privilege">{{ item.privilege.description }}</template></td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </div>
                </div>
            </div>
        </v-col>
        <v-col xl="3" lg="4" md="4" sm="5">
            <div class="sidebar">
                <div class="sidebar-top">
                    <div class="sidebar-date">{{ date.date }}</div>
                    <div class="sidebar-time">{{ date.time }}</div>
                    <h3 class="sidebar-title mt-7">Санаттар</h3>

                    <ul class="sidebar-categories">
                        <li v-for="item, index in categories" :class="{'active': selectedCategoryIndex == index}" :key="index" @click="selectedCategoryIndex = index">
                            {{ item.name }}
                        </li>
                    </ul>
                </div>
                <div class="sidebar-bottom">
                    <h3 class="sidebar-title mt-n2 mb-4">Дербес іздеу</h3>
                    <input v-model="searchInputVal" class="search-input" type="number" placeholder="ЖСН теріңіз" />
                    <button class="search-btn" type="button" @click="search">Тізімнен іздеу</button>
                </div>
            </div>
        </v-col>
    </v-row>
</template>
<script>
    export default {
        components: { 
        },
        mounted() {
            this.getData();

            this.updateDate();

            document.addEventListener('contextmenu', this.preventContextMenu);
            this.indervalId = setInterval(this.updateDate , 1000 * 60)
        },
        data: () => ({
            indervalId: null,
            isLoading: false,
            searchInputVal: null,
            searchVal: null,
            month: [
                'қаңтар',
                'ақпан',
                'наурыз',
                'сәуір',
                'мамыр',
                'маусым',
                'шілде',
                'тамыз',
                'қыркүйек',
                'қазан',
                'қараша',
                'желтоқсан'
            ],
            date: {},
            categories: [
                {
                    id: 0,
                    name: 'Барлығы бір тізіммен'
                },
                {
                    id: 2,
                    name: 'Табыс көзі бар отбасылар'
                },
                {
                    id: 3,
                    name: 'Аз қамтылған мүжәлсіз отбасы'
                },
                {
                    id: 4,
                    name: 'Мүгедек балалы немесе ата-анасы мүгедек отбасы'
                },
                {
                    id: 5,
                    name: 'Тұлдыр жетімдер немесе жартылай жетім/әкесі қайтыс болған немесе шешесі қайтыс болған отбасы'
                },
                {
                    id: 6,
                    name: 'Жұмысқа жарамды топтағы мүгедектер және пробация есебінде тұрған жұмыссыз азаматтар'
                }
            ],
            selectedCategoryIndex: 0,
            userList: []
        }),
        computed: {
            
        },
        methods: {
            preventContextMenu(event) {
                event.preventDefault()
            },
            updateDate() {
                const date = new Date();
                this.date = {
                    date: `${date.getUTCDate()} ${this.month[date.getUTCMonth()]} ${date.getUTCFullYear()} жыл`,
                    time: date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                };
            },
            async getData() {
                this.isLoading = true;
                
                
                await this.$http.get('/user/list/without/status').then((response) => {
                    this.userList = response.data.data;
                }).catch(() => {});
                this.isLoading = false;
            },
            search() {
                const found = this.userList.find(item => item.iin == this.searchInputVal);
                if(found) {
                    const catIndex = this.categories.findIndex(item => item.id == found.privilege.id);
                    if(catIndex != false) {
                        this.selectedCategoryIndex = catIndex;
                    } else {
                        this.selectedCategoryIndex = 0;
                    }

                    this.searchVal = this.searchInputVal;
                    this.searchInputVal = null;
                    setTimeout(() => {
                        this.$refs["rightBlock"].scroll({ top: 0 });
                        const y = this.$refs["active"][0].getBoundingClientRect().top - 350;
                        this.$refs["rightBlock"].scroll({
                            top: y,
                            behavior: 'smooth'
                        });
                    }, 300);
                } else {
                    this.$store.dispatch('alertAdd', {text: 'ЖСН жүйеде тіркелмеген ', type:'error'});
                }
            }
        },
        watch: {
            selectedCategoryIndex() {
                // this.searchVal = null;
            }
        },
        destroyed() {
            clearInterval(this.indervalId);
            document.removeEventListener('contextmenu', this.preventContextMenu);
        }
    }
</script>

<style scoped lang="scss">
.tablo-wrapper {
    user-select: none;
}
.sidebar {
    display: flex;
    flex-flow: column;
    height: calc(100vh);
    overflow-y: auto;
    > div {
        padding: 40px;
        color: #fff;
    }
    .sidebar-top {
        background-color: #006bce;
        .sidebar-date {
            font-weight: 300;
            font-size: 20px;
            letter-spacing: 0.3px;
        }
        .sidebar-time {
            font-weight: 300;
            font-size: 44px;
            margin-top: -10px;
        }
        .sidebar-categories {
            list-style: none;
            padding-left: 40px;
            font-size: 18px;
            font-weight: 300;
            text-decoration: underline;
            margin-top: 15px;
            cursor: pointer;
            li {
                position: relative;
                margin-bottom: 15px;
                &::before {
                    position: absolute;
                    content: '';
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    background-color: #006bce;
                    border: 12px solid #fff;
                    top: 1px;
                    left: -40px;
                }
                &.active::before {
                    border: 6px solid #fff;
                }
            }
        }
    }
    .sidebar-bottom {
        background-color: #4caf50;
        flex: 1;
    }
    .sidebar-title {
        font-weight: 500;
        font-size: 32px;
    }
    .sidebar-subtitle {
        font-size: 18px;
        font-weight: 300;
    }
    .search-input {
        display: block;
        border: 1px solid #fff;
        margin-top: 10px;
        margin-bottom: 15px;
        padding: 7px 10px;
        font-size: 18px;
        border-radius: 10px;
        background-color: #ffffff40;
        &::placeholder {
            color: white;
        }
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            /* display: none; <- Crashes Chrome on hover */
            -webkit-appearance: none;
            margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
        }

        &[type=number] {
            -moz-appearance:textfield; /* Firefox */
        }
    }
    .search-btn {
        background-color: #006bce;
        padding: 7px 15px;
        border-radius: 10px;
        border: 1px solid;
    }
}
.right-block {
    padding: 50px 40px;
    background-color: #ececec;
    height: 100vh;
    overflow-y: auto;
    position: relative;
    .main-block {
        background-color: #fff;
        .main-block-header {
            font-size: 22px;
            padding: 40px 50px;
            font-weight: 300;
            position: sticky;
            top: -50px;
            background-color: #fff;
            .caterody-name {
                font-weight: 900;
                font-size: 30px;
                color: #006bce;
                margin-top: -5px;
                margin-bottom: 10px;
            }
        }
        .main-block-content {
            padding-left: 50px;
            padding-right: 50px;
            font-size: 20px;
            td {
                padding: 15px;
                border-top: 1px solid #aaa;
            }
            .privilege-name {
                font-size: 16px;
            }
            tr.active {
                animation: blinkingBackground 1.5s linear 5;
            }
        }
    }
}
@keyframes blinkingBackground{
		0%		{ background-color: #fff;}
		50%		{ background-color: #ffc107;}
		100%		{ background-color: #fff;}
	}
</style>

<style>
    html {
        overflow-y: auto;
    }
</style>